<div class="row sticky-top bg-white" style="top: 5.5rem">
  <div class="col-md-12">
    <app-alerting></app-alerting>
  </div>
  <div class="col-md-12">
    <app-action-nav-bar>
      @if (hasCurrentVersionInvoice()
      && (appContext.isHarbourDuesReviewer() || appContext.isAdmin())) {
        <button type="submit" class="btn btn-outline-secondary me-2" tabindex="-1" form="harbour_dues_form" (click)="onReject()">
          Reject
        </button>

        <button type="submit" class="btn btn-primary me-2" tabindex="-1" form="harbour_dues_form" (click)="onAccept()">
          Accept
        </button>
      }

      @if (canEdit()
      && !saveAndSendDisabled()) {
        <div class="btn-group fieldset enabled">
          <button type="submit" class="btn btn-info" tabindex="-1" form="harbour_dues_form" (click)="onSaveAndSend()">
            Save and send
          </button>
          @if (canSaveUndeclaredDeclaration()) {
            <button type="button" class="btn btn-info dropdown-toggle dropdown-toggle-split"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <span class="visually-hidden">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <a id="save" class="dropdown-item text-success" href="#" role="button"
                  (click)="onSaveDraft($event)">
                <i class="fa fa-save" aria-hidden="true"></i> Save
              </a>
            </div>
          }
        </div>
      } @else if(canSaveUndeclaredDeclaration()) {
        <button type="submit" class="btn btn-info" tabindex="-1" form="harbour_dues_form" (click)="onSaveDraft($event)">
          Save
        </button>
      }
    </app-action-nav-bar>
  </div>
  <div class="col-md-12 bg-light border-bottom">
    <div class="row page-section px-0">
      <div class="col"></div>
      <div class="col-8">
        @if (declarationTabs()  .length > 1) {
          <app-tab-panel (tabChange)="onTabChange($event.index)" [sticky]="true"
                         [alwaysRender]="true">
            @for (t of declarationTabs(); track t) {
              <app-tab-item>
                <span class="tab-item">{{ invoicePeriod(t.invoiceStart, t.invoiceEnd) }}</span>
              </app-tab-item>
            }
          </app-tab-panel>
        }
      </div>
      <div class="col"></div>
    </div>
  </div>
</div>
